<template>
  <div>
    <el-popover placement="bottom" trigger="manual" :value="popShow">
      <el-table
        :data="options"
        border
        stripe
        size="mini"
        max-height="300"
        :header-cell-style="{background:'#D7D7D7',color:'#000'}"
        :row-style="{height:'30px'}"
        @row-click="handleChooseRow"
      >
        <el-table-column width="150" property="code" label="Item Code"></el-table-column>
        <el-table-column width="350" property="name" label="Item Name"></el-table-column>
        <el-table-column
          width="60"
          property="stock"
          label="Stock"
          :formatter="formatStock"
          align="right"
        ></el-table-column>
        <div slot="empty">
          <span class="popover-table-empty-text">No Data</span>
        </div>
      </el-table>
      <el-input
        slot="reference"
        v-model="tValue"
        placeholder="Search & select"
        @blur="handleBlur"
        clearable
        size="mini"
      ></el-input>
    </el-popover>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { getProductsInfo } from '../api'
import { productTpl } from '../store/order-edit'

let searchHandler = null
let prevenTwiceTriggerBug = true

export default {
  name: 'ColumnProductCodeSelectPopper',
  props: {
    rowId: {
      type: [String, Number],
      required: true
    },
    source: {
      type: String,
      default: 'editOrderLine'
    }
  },
  data () {
    return {
      localValue: '',
      options: [],
      popShow: false,
      localProduct: {}
    }
  },
  created () {
    if (this.source === 'editOrderLine') {
      this.localProduct = this.product(this.rowId)
    } else {
      this.localProduct = this.rProduct(this.rowId).product
    }
    this.localValue = this.localProduct.code
    this.bus.$on(`name-changed-${this.rowId}`, name => {
      if (this.source !== 'report') {
        this.handleDataSearch({ name })
      } else if (prevenTwiceTriggerBug && this.source === 'report') {
        this.handleDataSearch({ name })
      }
      prevenTwiceTriggerBug = !prevenTwiceTriggerBug // 专门针对 Report页面的触发2次bug
    })
    this.bus.$on(`name-poper-leave-${this.rowId}`, name => {
      if (name !== this.localProduct.name) {
        this.clearSelect()
      }
      this.popShow = false
    })
  },
  beforeDestroy () {
    this.bus.$off(`name-changed-${this.rowId}`)
    this.bus.$off(`name-poper-leave-${this.rowId}`)
  },
  computed: {
    ...mapGetters({
      product: 'edit/lineProduct',
      rProduct: 'report/product',
      csrId: 'edit/csrId'
    }),
    tValue: {
      get () {
        return this.localValue
      },
      set (val) {
        this.localValue = val
        if (val) {
          if (!searchHandler) {
            searchHandler = setTimeout(() => {
              searchHandler = null
              this.handleDataSearch({ code: this.localValue })
            }, 700)
          }
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      setProduct: 'edit/setProduct',
      setProductForReport: 'report/setProduct'
    }),
    async handleDataSearch (param) {
      this.popShow = true
      if (this.csrId) {
        param.cId = this.csrId
      }
      param['sortType'] = 7
      this.options = (await getProductsInfo(param)).data
    },
    handleChooseRow (row) {
      const product = {
        id: row.id,
        code: row.code,
        name: row.name,
        stocks: row.stocks,
        prices: row.prices,
        costPrice: row.costPrice,
        unit: row.unit,
        stock_3rdP: row.stock_3rdP
      }
      this.productSelected(product)
      this.popShow = false
    },
    handleBlur () {
      if (this.source === 'editOrderLine') {
        if (this.localValue !== this.product(this.rowId).code) {
          this.clearSelect()
        }
      } else {
        if (this.localValue !== this.rProduct(this.rowId).product.code) {
          this.clearSelect()
        }
      }

      this.popShow = false
    },

    clearSelect () {
      this.localProduct = {}
      this.localValue = ''
      const product = Object.create(productTpl)
      this.productSelected(product)
    },

    productSelected (product) {
      // console.log(this.rowId)
      this.localProduct = product
      if (this.source === 'editOrderLine') {
        this.setProduct({ id: this.rowId, product: product })
      } else {
        // console.log(product);
        this.setProductForReport({ id: this.rowId, product })
      }

      this.bus.$emit(`product-selected-${this.rowId}`, product)
      this.localValue = product.code
    },

    formatStock (row) {
      return row.stocks.reduce((sum, item) => sum + item.stock, 0)
    }
  },
  inject: ['bus']
}
</script>
